import { useTranslation } from 'react-i18next';

import {
    Flex,
    IconReport,
    TextButton,
} from '@myphx-engineering/phx-design-system';

type PARequiredAlertProps = {
    toggle?: () => void;
};

export const PARequiredAlert = ({ toggle }: PARequiredAlertProps) => {
    const { t } = useTranslation();

    return (
        <Flex>
            <TextButton
                LeftIcon={IconReport}
                color="warning"
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    toggle?.();
                }}
            >
                {t('common.drugCoverageAlerts.paRequired.buttonText')}
            </TextButton>
        </Flex>
    );
};
